import script from "./ArgonCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonCheckbox.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__